<template>
  <div class="lotto-vi-tab">
    <div class="grid grid-cols-2 gap-2 input-tab">
      <button
        :class="{'active': currentMode == MODE_ADD}"
        type="button"
        @click="onSelect(MODE_ADD)"
      >
        <div class="flex items-center justify-center font-bold">
          ร่วมออกผลรางวัล
        </div>
      </button>
      <button
        :class="{'active': currentMode == MODE_PLAY}"
        type="button"
        @click="onSelect(MODE_PLAY)"
      >
        <div class="flex items-center justify-center font-bold">
          หน้าแทง
        </div>
      </button>
    </div>
  </div>
</template>
<script>
const MODE_ADD = 'add'
const MODE_PLAY = 'play'

export default {
  props : { 
    currentMode: {
      type: String,
      default: MODE_ADD
    },
  },
  computed : { 
    MODE_ADD: () => MODE_ADD,
    MODE_PLAY: () => MODE_PLAY,
  },
  methods : {
    onSelect (menu) { 
      this.$emit('change', menu)
    },
  }
}
</script>

<style scoped>

.lotto-vi-tab .input-tab button {
  border-style: solid;
  border-color: var(--bg-secondary-color-v2);
  border-width: 1px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  color: var(--bg-secondary-color-v2);
}

.lotto-vi-tab .input-tab button.active {
  --tw-bg-opacity: 1;
  background-color: var(--bg-secondary-color-v2);
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.btn, [type=button], [type=submit], button {
  align-items: center;
  border-radius: .375rem;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 1rem;
  font-weight: 500;
  height: auto;
  justify-content: center;
  line-height: 1.5rem;
  padding: .5rem .75rem;
  position: relative;
  touch-action: manipulation;
  transition: all .3s cubic-bezier(.4,0,.2,1);
}
</style>